import { QuestDto } from "./quest.dto";

export interface ArticleDto {
  id: string;
  title: string;
  image: string;
  type: ArticleType;
  readingTime: number;
  points: {
    reading: number;
    quiz: number;
  };
  isReaded: boolean;
  isQuizzesValidated: boolean;
  nextArticle: NextArticleDto | null;
  quest: QuestDto | null;
}

export interface ArticleHotNewsDto extends ArticleDto {
  type: ArticleType.HOT_NEWS;
  isClaimed: boolean;
}

export enum ArticleType {
  HOT_NEWS = "hot_news",
  DEFAULT = "default",
}

type NextArticleDto = Pick<ArticleDto, "id" | "title" | "image"> & {
  url: string;
};
